// extracted by mini-css-extract-plugin
export var blue = "alma-link-module--blue--feb80";
export var buttonContainer = "alma-link-module--buttonContainer--6d73a";
export var buttonLarge = "alma-link-module--buttonLarge--696da";
export var buttonMedium = "alma-link-module--buttonMedium--22a85";
export var buttonSmall = "alma-link-module--buttonSmall--7dfa2";
export var componentContainer = "alma-link-module--componentContainer--96ee9";
export var cream = "alma-link-module--cream--7b136";
export var dark = "alma-link-module--dark--3b715";
export var darkForest = "alma-link-module--darkForest--d7f5d";
export var gold = "alma-link-module--gold--92e67";
export var gray = "alma-link-module--gray--84d93";
export var leftArrow = "alma-link-module--leftArrow--bef2b";
export var light = "alma-link-module--light--f90d0";
export var lightGreen = "alma-link-module--lightGreen--7790e";
export var linkContainer = "alma-link-module--linkContainer--8b405";
export var matcha = "alma-link-module--matcha--89fa9";
export var mediumBlue = "alma-link-module--mediumBlue--59053";
export var rightArrow = "alma-link-module--rightArrow--fa006";
export var rust = "alma-link-module--rust--5801a";
export var underlined = "alma-link-module--underlined--c7a63";
export var withBorder = "alma-link-module--withBorder--f7914";